import { useCallback } from 'react';
import { httpClient, ROOT_URL } from '../../App';
import { message } from 'antd';
import { getErrorMessage } from '../../api/error';

export const useDeleteUser = () => {
  const deleteUser = useCallback(async (id: number) => {
    try {
      await httpClient.delete(`${ROOT_URL}/api/v1/users/${id}`);
    } catch (error) {
      message.error(getErrorMessage(error));
    }
  }, []);

  return { deleteUser };
};
